import { ItemEngineStateEntity } from "@hds-products/event-runtime-entities-common";
import { FrankServiceEntityPersistence } from "@hds/entity-lib";

class ItemEngineStateClientEntity extends ItemEngineStateEntity {
    constructor(ep, seedData = {}, options = {}) {
        super(ep, seedData, options);
    }
    static createInstance(baseUri, seedData, customHeaderFn) {
        const ep = ItemEngineStateClientEntity.createEntityPersistence(baseUri, customHeaderFn);
        return new ItemEngineStateClientEntity(ep, seedData);
    }
    static createEntityPersistence(baseUri, customHeaderFn) {
        const ep = new FrankServiceEntityPersistence(baseUri, ItemEngineStateClientEntity.prototype._meta.entityName, customHeaderFn);
        return ep;
    }
    /*****************************************************/
    // START OVERRIDDEN PROPERTIES
    /*****************************************************/
    set eventDetailId(newEventDetailId) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set itemId(newItemId) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set biddingRules(newBiddingRules) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set eventTypeBiddingRules(newEventTypeBiddingRules) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set prebids(newPrebids) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    /*****************************************************/
    // END OVERRIDDEN PROPERTIES
    // START OVERRIDDEN METHODS
    /*****************************************************/
    create() { throw new Error('METHOD_NOT_ALLOWED'); }
    upsert() { throw new Error('METHOD_NOT_ALLOWED'); }
    update() { throw new Error('METHOD_NOT_ALLOWED'); }
    patch() { throw new Error('METHOD_NOT_ALLOWED'); }
    replace() { throw new Error('METHOD_NOT_ALLOWED'); }
    delete() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

export { ItemEngineStateClientEntity };
export default ItemEngineStateClientEntity;